/* globals svgedit */
/* jslint vars: true, eqeq: true, continue: true, forin: true */
/**
 * Package: svedit.history
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2010 Jeff Schiller
 */

(function () {
  'use strict';
  svgedit.history = svgedit.history || {};

  // Group: Undo/Redo history management
  svgedit.history.HistoryEventTypes = {
    BEFORE_APPLY: 'before_apply',
    AFTER_APPLY: 'after_apply',
    BEFORE_UNAPPLY: 'before_unapply',
    AFTER_UNAPPLY: 'after_unapply'
  };

  svgedit.history.UndoManager = function (historyEventHandler) {
    this.handler_ = historyEventHandler || null;
    this.undoStackPointer = 0;
    this.undoStack = [];

    // this is the stack that stores the original values, the elements and
    // the attribute name for begin/finish
    this.undoChangeStackPointer = -1;
    this.undoableChangeStack = [];
  };

  svgedit.history.UndoManager.prototype.toggleUndoStackLock = function (status) {
    this.lockStatus = status;
  };

  svgedit.history.UndoManager.prototype.resetUndoStack = function () {
    this.undoStack = [];
    this.undoStackPointer = 0;
    $('#ik-editor').trigger('ik.editor.canvas.history.reset');
  };

  svgedit.history.UndoManager.prototype.getUndoStackSize = function () {
    return this.undoStackPointer;
  };

  svgedit.history.UndoManager.prototype.getRedoStackSize = function () {
    return this.undoStack.length - this.undoStackPointer;
  };

  svgedit.history.UndoManager.prototype.getNextUndoCommandText = function () {
    return this.undoStackPointer > 0 ? this.undoStack[this.undoStackPointer - 1].getText() : '';
  };

  svgedit.history.UndoManager.prototype.getNextRedoCommandText = function () {
    return this.undoStackPointer < this.undoStack.length ? this.undoStack[this.undoStackPointer].getText() : '';
  };

  svgedit.history.UndoManager.prototype.undo = function () {
    if (this.undoStackPointer > 0) {
      const cmd = this.undoStack[--this.undoStackPointer];
      cmd.unapply(this.handler_);
    }
    $('#ik-editor').trigger('ik.editor.canvas.history.undo');
  };

  svgedit.history.UndoManager.prototype.redo = function () {
    if (this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0) {
      const cmd = this.undoStack[this.undoStackPointer++];
      cmd.apply(this.handler_);
    }
    $('#ik-editor').trigger('ik.editor.canvas.history.redo');
  };

  svgedit.history.UndoManager.prototype.getStackInfo = function (offset) {
    offset = offset || 0;

    const cmd = this.undoStack[this.undoStackPointer + offset];
    return { type: cmd ? cmd.text : 'unknown' };
  };

  svgedit.history.UndoManager.prototype.addCommandToHistory = function (cmd) {
    if (this.lockStatus) return;
    cmd.storedTime = new Date();

    // FIXME: we MUST compress consecutive text changes to the same element
    // (right now each keystroke is saved as a separate command that includes the
    // entire text contents of the text element)
    // TODO: consider limiting the history that we store here (need to do some slicing)

    // if our stack pointer is not at the end, then we have to remove
    // all commands after the pointer and insert the new command
    if (this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0) {
      this.undoStack = this.undoStack.splice(0, this.undoStackPointer);
    }
    this.undoStack.push(cmd);
    this.undoStackPointer = this.undoStack.length;
    $('#ik-editor').trigger('ik.editor.canvas.history.add');

    // console.log(this.undoStack, this.undoStackPointer);
  };

  // Function: svgedit.history.UndoManager.beginUndoableChange
  // This function tells the canvas to remember the old values of the
  // attrName attribute for each element sent in.  The elements and values
  // are stored on a stack, so the next call to finishUndoableChange() will
  // pop the elements and old values off the stack, gets the current values
  // from the DOM and uses all of these to construct the undo-able command.
  //
  // Parameters:
  // attrName - The name of the attribute being changed
  // elems - Array of DOM elements being changed
  svgedit.history.UndoManager.prototype.beginUndoableChange = function (attrName, elems) {
    const p = ++this.undoChangeStackPointer;
    let i = elems.length;
    const oldValues = new Array(i); const elements = new Array(i);
    const svgCanvas = INKIVE.Tool && INKIVE.Tool.getInstance().editor.canvas;

    while (i--) {
      var elem = elems[i];
      if (elem == null) { continue; }
      elements[i] = elem;

      if (attrName == '#fill') oldValues[i] = INKIVE.Helpers.getColor(elem, 'fill');
      else if (attrName == '#bullets') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.bullets;
      else if (attrName == '#text-anchor') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.text_anchor;
      else if (attrName == '#text-decoration')oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.text_decoration;
      else if (attrName == '#font-weight') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.font_weight;
      else if (attrName == '#font-style') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.font_style;
      else if (attrName == '#font-family') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.font_family;
      else if (attrName == '#font-size') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.font_size;
      else if (attrName == '#word-spacing') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.word_spacing;
      else if (attrName == '#letter-spacing') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.letter_spacing;
      else if (attrName == '#paragraph-spacing') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.paragraph_spacing;
      else if (attrName == '#first-line-margin') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.first_line_margin;
      else if (attrName == '#right-margin') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.right_margin;
      else if (attrName == '#line-spacing') oldValues[i] = new INKIVE.Text.Textarea().setDOM(elem).text.line_spacing;
      else if (attrName == '#stroke') oldValues[i] = INKIVE.Helpers.getColor(elem, 'stroke');
      else if (attrName.match(/^#set_/)) oldValues[i] = INKIVE.Helpers.getColor(elem, attrName.replace('#', ''));
      else if (attrName == '#layout-delete') {
        oldValues[i] = {};
        _.each(['xlink:href', 'x', 'y', 'width', 'height'], function (attName) {
          oldValues[i][attName] = elem.getAttribute(attName);
        });
      } else oldValues[i] = elem.getAttribute(attrName);
    }

    this.undoableChangeStack[p] = {
      attrName,
      oldValues,
      elements
    };
  };

  // Function: svgedit.history.UndoManager.finishUndoableChange
  // This function returns a BatchCommand object which summarizes the
  // change since beginUndoableChange was called.  The command can then
  // be added to the command history
  //
  // Returns:
  // Batch command object with resulting changes
  svgedit.history.UndoManager.prototype.finishUndoableChange = function () {
    const p = this.undoChangeStackPointer--;
    const changeset = this.undoableChangeStack[p];
    let i = changeset.elements.length;
    const attrName = changeset.attrName;
    const batchCmd = new svgedit.history.BatchCommand('Change ' + attrName);

    while (i--) {
      const elem = changeset.elements[i];
      if (elem == null) { continue; }
      const changes = {};
      changes[attrName] = changeset.oldValues[i];
      if (changes[attrName] != elem.getAttribute(attrName)) {
        batchCmd.addSubCommand(new svgedit.history.ChangeElementCommand(elem, changes, attrName));
      }
    }
    this.undoableChangeStack[p] = null;
    return batchCmd;
  };
})();
